var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"no-fade":"","size":"xl","hide-header":"","hide-footer":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('AbsBox',{staticClass:"bg-dark"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }